<template>
  <md-card>
    <md-card-content>

      <div class="md-layout">
        <div class="md-layout-item">
          <autoextra :collection="document" v-slot="{item,last,index}">
            <div  :class="{last: last}">
              <div v-if="item.vehicle_document_type || item.vehicle_document_type == 0 || last" class="columns">
                <label :id="'labelDocumentFlag_'+index" style="font-weight:bold;" class="label">{{last ? 'New ' : ''}}Document {{!last ? index + 1 : ''}}</label>
                <div class="md-layout md-gutter">

                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px;">
                  <input v-model="item.id" :readonly="true" type="hidden"/>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Document Type</label>
                      <md-select v-model="item.vehicle_document_type" @md-selected="onChangeDocumentType()" required>
                        <md-option value="0">STNK</md-option>
                        <md-option value="1">BPKB</md-option>
                        <md-option value="2">KEUR</md-option>
                        <md-option value="3">TERA</md-option>
                        <md-option value="4">SRUT</md-option>
                        <md-option value="5">KP</md-option>
                      </md-select>
                    </md-field>
                    <span :id="'flagDocumentType'" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Document No</label>
                      <md-input v-model="item.vehicle_document_no" :disabled="!item.vehicle_document_type && item.vehicle_document_type != 0" @change="onChangeDocumentNo(index, item.vehicle_document_no)" />
                    
                    </md-field>
                    <span :id="'flagDocument_'+index" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                      <label class="md-layout-item md-size-15 md-form-label" > Expire Date</label>
                    <md-field >
                      <md-input type="date" v-model="item.vehicle_document_expire_date" :disabled="!item.vehicle_document_type && item.vehicle_document_type != 0" @change="onChangeDocumentExpire(index, item.vehicle_document_expire_date)" />
                   
                    </md-field>
                     <span :id="'flagExpire_'+index" style="display:none; color:red;">Field is required</span>
                  </div>

                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                      <label class="md-layout-item md-size-15 md-form-label" >Tax Expire Date</label>
                    <md-field >
                      <md-input type="date" v-model="item.vehicle_document_tax_expire_date" :disabled="!item.vehicle_document_type && item.vehicle_document_type != 0" />
                    </md-field>
                  </div>
                  
                  <div class="md-layout-item md-small-size-100" style="margin-bottom:10px;">
                    <md-field >
                      <label class="label" >Remark</label>
                      <md-textarea v-model="item.vehicle_document_remark" md-counter="150" maxlength="150" :disabled="!item.vehicle_document_type && item.vehicle_document_type != 0" md-autogrow></md-textarea>
                    </md-field>
                  </div>

                  <div class="md-layout-item md-small-size-100">
                    <md-field class="md-invalid">
                    <label >Upload File/Photo</label>
                      <md-file 
                      
                        ref="document"
                        @change="on_change_attach_doc(item.vehicle_attach_document_view,index)"
                        v-model="item.vehicle_attach_document_view"
                        accept="image/jpeg,image/png,application/pdf"
                        :disabled="!item.vehicle_document_type && item.vehicle_document_type != 0"
                      />
                      <validation-error
                        :errors="apiValidationErrors.vehicle_document_attach"
                      />
                    </md-field>
                     <p v-if="item.vehicle_document_attach && item.vehicle_document_attach.type != 'image/jpeg' && item.vehicle_document_attach.type != 'image/png'" class="mb-0" style="text-align:center;">size: {{ (item.vehicle_document_attach.size / 1048576).toFixed(2) }}MB</p>
                      
                  </div>
                </div>
                  <div class="md-layout-item md-size-50 md-small-size-100" style="margin-bottom:10px; ">
                   
                      
                      <template v-if="item.vehicle_document_attach && (item.vehicle_document_attach.type == 'image/jpeg' || item.vehicle_document_attach.type == 'image/png')" style="width:100% ">

                        <viewer class="pointer" :src="item.vehicle_document_attach.base64">
                        <img style="width: auto; max-height:400px; display: block; margin:auto;"
                         
                          :src="item.vehicle_document_attach.base64"
                          class="img-fluid"
                        />
                        </viewer>
                        <!-- <p class="mb-0">file name: {{ file_attach_document.name }}</p> -->
                        <p class="mb-0" style="text-align:center;">size: {{ (item.vehicle_document_attach.size / 1048576).toFixed(2) }}MB</p>
                      </template>
                      <template v-if="!item.vehicle_document_attach && item.url_vehicle_document_file">
                      <!-- <template v-if="!file_attach_document && item.url_vehicle_document_file"> -->
                        <template v-if="get_url_extension_image(item.url_vehicle_document_file)">
                          <span style="color:green"
                            >Current Photo:
                          </span>
                          <viewer class="pointer">
                          <img style="width: auto; max-height:400px; display: block; margin:auto;"
                              :src="item.url_vehicle_document_file"
                              
                              class="img-fluid"
                            />
                          </viewer>
                        </template>
                        <template v-else>
                          <span style="color:green"
                            >Current File:
                          </span>
                          <a target="_blank" :href="item.url_vehicle_document_file">{{item.url_vehicle_document_file.split('/').pop()}}</a>
                        </template>
                        <!-- <span style="color:green">
                            Current Document:
                          </span>
                          <a v-if="item.url_vehicle_document_file" :href="item.url_vehicle_document_file" target="_blank">
                          stnk_{{ item.vehicle_police_no }}
                          </a> -->
                      </template>
                  </div>
                 
                  <md-card-actions style="border:none;">
                  <md-button class="md-danger md-dense"  @click="deleteColumn(index)" v-if="item.vehicle_document_type || item.vehicle_document_type==0">
                    delete
                  </md-button>
                  </md-card-actions>
                </div>            
              </div>
            </div>
            </autoextra>
          </div>
        </div>
            
   
    </md-card-content>
  </md-card>
</template>
<script>
import { ValidationError } from "@/components";
import formMixin from "@/mixins/form-mixin";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import  Autoextra  from 'vue-autoextra';
import Swal from "sweetalert2";

extend("category", {
  ...required,
  message: "Category field is required",
});
extend("policeno", {
  ...required,
  message: "Police No. field is required",
});
extend("model", {
  ...required,
  message: "Model field is required",
});
extend("type", {
  ...required,
  message: "Eshed field is required",
});

export default {
  name: "vehicle-card",

    props: ["vehicle"],
  components: { ValidationError, Autoextra },

  mixins: [formMixin],
  
  data() {
    return {
      document: [],
      // url_vehicle_document_file: null,
      // vehicle_attach_keur_url:null,
    };
  },

//   created() {
//     this.onOpen();
//   },

  methods: {

    getData() {
           // this.$emit('data', this.document)
           this.vehicle.document = this.document
        },

    async getDataParent() { 
        // console.log(this.driver.vehicle_document);
        // this.identity = this.driver.vehicle_document
        //loop nilai identity untuk membuat autoextra row
        this.vehicle.vehicle_document.forEach((value, index) => {
          this.$set(this.document, index, {
                  id : value.id,
                  vehicle_document_type : value.vehicle_document_type,
                  vehicle_document_no : value.vehicle_document_no,
                  vehicle_document_expire_date : value.vehicle_document_expire_date,
                  vehicle_document_tax_expire_date : value.vehicle_document_tax_expire_date,
                  vehicle_document_remark : value.vehicle_document_remark,
                  vehicle_attach_document_view: null,
                  vehicle_document_attach :null,
                  url_vehicle_document_file : value.url_vehicle_document_file

                });
          });
        console.log(this.document);
      },
   

    get_url_extension_image(url) {
        const image_format = ["jpg", "jpeg", "pjpeg", "pjp", "png", "svg", "webp"];
        return image_format.includes(url.split(/[#?]/)[0].split('.').pop().trim());
    },

    onChangeDocumentNo(index,data){
        let error = document.getElementById("flagDocument_"+index);
        if(data!=null && data!=""){
        error.style.display = "none"
        }
        else{
          error.style.display = "block"
        }

      },

      onChangeDocumentExpire(index,data){
        let error = document.getElementById("flagExpire_"+index);
        if(data!=null && data!=""){
        error.style.display = "none"
        }
        else{
          error.style.display = "block"
        }

      },

    onChangeDocumentType(){
       let error = document.getElementById("flagDocumentType");
        error.style.display = "none"
      flagDocumentType
      var filter = this.document.filter(function(el) {
           console.log(el);
            return el != null;
          });
          console.log(filter)
          var int= 0
          for (const [key, value] of Object.entries(filter)) {
                        console.log(key);
                        console.log(value);
                        if(!value.vehicle_document_type  && value.vehicle_document_type != 0){
                          int++
                        }
                        else{
                          console.log(key-int);
                          this.$set(this.document, key-int, {
                             id : value.id,
                            vehicle_document_type : value.vehicle_document_type,
                            vehicle_document_no : value.vehicle_document_no,
                            vehicle_document_expire_date : value.vehicle_document_expire_date,
                            vehicle_document_tax_expire_date : value.vehicle_document_tax_expire_date,
                            vehicle_document_remark : value.vehicle_document_remark,
                            vehicle_document_attach : value.vehicle_document_attach,
                            vehicle_attach_document_view : value.vehicle_attach_document_view,
                            url_vehicle_document_file : value.url_vehicle_document_file,
                            
                          });
                          if(int!=0){
                            this.$set(this.document, key, {
                               id :null,
                              vehicle_document_type : null,
                              vehicle_document_no : null,
                              vehicle_document_expire_date : null,
                              vehicle_document_tax_expire_date : null,
                              vehicle_document_remark : null,
                              vehicle_document_attach : null,
                            vehicle_attach_document_view : null,
                              url_vehicle_document_file : null,
                              
                            });
                          }
                          
                          int= 0
                        }
                        

                      }
      
    },

    on_change_attach_doc(event,index) {
        console.log(index)
      var input = event.target;
      if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
          if(input.files[0]){
          this.sizeTobig(input.files[0].size) 
          }
          // this.resetFile('photo_driver')
          // this.vehicle_document_attach = null
          // this.vehicle_document_attach = null

          this.$set(this.document, index, {
                  thiid : this.document[index].id,
                  vehicle_document_type : this.document[index].vehicle_document_type,
                  vehicle_document_no : this.document[index].vehicle_document_no,
                  vehicle_document_expire_date : this.document[index].vehicle_document_expire_date,
                  vehicle_document_tax_expire_date : this.document[index].vehicle_document_tax_expire_date,
                  vehicle_document_remark : this.document[index].vehicle_document_remark,
                  vehicle_document_attach : null,
                  vehicle_attach_document_view : null,
                  url_vehicle_document_file : this.document[index].url_vehicle_document_file
                  
                });

          
          //console.log(this.vehicle_document_attach)
          return
        }
      //check apakah data ada
      if (input.files) {
        var reader = new FileReader();
        //read file
        reader.onload = (e) => {
          //set array filedata
          const fileData = {
            name: input.files[0].name,
            size: input.files[0].size,
            lastModified: input.files[0].lastModified,
            lastModifiedDate: input.files[0].lastModifiedDate,
            type: input.files[0].type,
            base64: e.target.result,
          };
          //set var berdasarkan fildedata
          //this.vehicle_document_attach = fileData;
           this.$set(this.document, index, {
                  id : this.document[index].id,
                  vehicle_document_type : this.document[index].vehicle_document_type,
                  vehicle_document_no : this.document[index].vehicle_document_no,
                  vehicle_document_expire_date : this.document[index].vehicle_document_expire_date,
                  vehicle_document_tax_expire_date : this.document[index].vehicle_document_tax_expire_date,
                  vehicle_document_remark : this.document[index].vehicle_document_remark,
                  vehicle_attach_document_view : fileData.name,
                  vehicle_document_attach : fileData,
                  url_vehicle_document_file : this.document[index].url_vehicle_document_file
                  
                });

        };
        reader.readAsDataURL(input.files[0]);
      }
    },

    async validateForm() {
      const vehicle_document_type = this.$refs['vehicle_document_type'];
      
      let result = []
      if(Object.keys(this.document).length != 0){
        for (const [key, value] of Object.entries(this.document)) {
          console.log(value.vehicle_document_no+' - '+value.vehicle_document_expire_date)
          if((value.vehicle_document_type || value.vehicle_document_type == 0) && (!value.vehicle_document_no || !value.vehicle_document_expire_date)){
            if(!value.vehicle_document_no){
              document.getElementById("flagDocument_"+key).style.display = "block"
            }
            if(!value.vehicle_document_expire_date){
              document.getElementById("flagExpire_"+key).style.display = "block"
            }
            document.getElementById("labelDocumentFlag_"+key).scrollIntoView({behavior: 'auto'});
            result.push(false)
          }
        }
      }

      if(this.document.length == 0){
            document.getElementById("flagDocumentType").style.display = "block"
            document.getElementById("labelDocumentFlag_0").scrollIntoView({behavior: 'auto'});
            result.push(false)
      }
      return result.every(Boolean)
    },

    // on_change_attach_doc: function(event) {
    //   var input = event.target;
    //   // if((input.files[0].size / 1048576).toFixed(2) > 3){
    //   //     this.sizeTobig(input.files[0].size) 
    //   if(!input.files[0] || (input.files[0].size / 1048576).toFixed(2) > 3){
    //       if(input.files[0]){
    //       this.sizeTobig(input.files[0].size) 
    //       }
    //       this.resetFile('stnk')
    //       this.item.vehicle_document_attach = null
    //       this.file_attach_document = null
    //       return
    //     }
    //   //check apakah data ada
    //   if (input.files) {
    //     var reader = new FileReader();
    //     //read file
    //     reader.onload = (e) => {
    //       //set array filedata
    //       const fileData = {
    //         name: input.files[0].name,
    //         size: input.files[0].size,
    //         lastModified: input.files[0].lastModified,
    //         lastModifiedDate: input.files[0].lastModifiedDate,
    //         type: input.files[0].type,
    //         base64: e.target.result,
    //       };
    //       //set var berdasarkan fildedata
    //       this.file_attach_document = fileData;
    //     };
    //     reader.readAsDataURL(input.files[0]);
    //   }
    // },

    deleteColumn(index){
        if (index > -1) {
           this.document.splice(index, 1)
        }
        
      },

    sizeTobig(size){
      Swal.fire({
          icon: 'error',
          title: 'File is to big ('+(size / 1048576).toFixed(2)+'MB)',
          text: 'Maximum attachment file size 3MB',
        })
    },
     resetFile(ref) {
      this.$refs[ref].clearField()
    },
    
  },
};
</script>

<style>
.pointer {cursor: pointer;}
.photo_list{
    display: block;
  margin-left: auto;
  margin-right: auto;
  width: 40%;
}

.columns{
  margin-bottom: 3ex;
  border-bottom: 5px solid black;
}
</style>
